import React from 'react';

export const ModeratorIcon = props =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="80"
    viewBox="0 0 80 80"
    style={{
      fillRule: 'evenodd',
    }}
    {...props}
  >
    <path
      d="M728.241,771.059L707.584,769a3.6,3.6,0,0,1-2.96-2.305l-7.4-18.876a3.478,3.478,0,0,0-6.57,0L683.316,766.7a3.523,3.523,0,0,1-2.96,2.305L659.7,771.059c-3.078.312-4.321,4.361-2.013,6.541l15.567,14.39a3.846,3.846,0,0,1,1.125,3.676L669.7,815.849c-0.711,3.177,2.545,5.794,5.268,4.112l17.224-10.653a3.429,3.429,0,0,1,3.611,0l17.224,10.653c2.723,1.682,5.978-.872,5.268-4.112l-4.617-20.183a3.846,3.846,0,0,1,1.125-3.676l15.567-14.39A3.853,3.853,0,0,0,728.241,771.059Z"
      transform="translate(-654 -743)"
    />
  </svg>;



// WEBPACK FOOTER //
// ./app/components/icons/moderator-icon.js